<template>
  <el-dialog :title="title"
             :visible.sync="centerDialogVisible"
             :close-on-click-modal="false"
             width="50%"
             center>
    <img :src="imageUrl" />
    <span slot="footer"
          class="dialog-footer">
      <el-button type="primary"
                 @click="centerDialogVisible = false">{{$t('btn.confirm')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  name: 'Index',
  props: {
    data: Object || String,
    title: String,
    download: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      centerDialogVisible: false,
      imageUrl: ''
    };
  },
  methods: {
    toBase64(file) {
      const that = this;
      const reader = new FileReader();
      reader.onloadend = function () {
        that.imageUrl = reader.result;
      };
      let blob;
      if (!(file instanceof Blob)) {
        blob = new Blob([file]);
      } else {
        blob = file;
      }
      reader.readAsDataURL(blob);
    },
    handleDownload() {
      this.$downloadFile(this.data, this.title);
    }
  },
  mounted: function () {
    this.$nextTick(() => {
      this.toBase64(this.data);
    });
  }
};
</script>

<style lang="less" scoped>
img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// index.vue?fd2ec59e